import { render } from "./ObjectDisplaySmall.vue?vue&type=template&id=3b2a134e&scoped=true"
import script from "./ObjectDisplaySmall.vue?vue&type=script&lang=js"
export * from "./ObjectDisplaySmall.vue?vue&type=script&lang=js"

import "./ObjectDisplaySmall.vue?vue&type=style&index=0&id=3b2a134e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2a134e"]])

export default __exports__